
//var dt = require('datatables.net')(window, $);


// SCRIPTS

//to make discoverable from cshtml
import { SecureHomePage } from './home/home.page'; export { SecureHomePage };
import { ProjectDirectoryPage } from './communications/directory.page'; export { ProjectDirectoryPage };
import { SecureGalleryPage } from './resources/gallery.page'; export { SecureGalleryPage };
import { SecureConsortiumPage } from './resources/consortium.page'; export { SecureConsortiumPage };
import { SecureAnnouncementsPage } from './announcements/announcements.page'; export { SecureAnnouncementsPage };
import { EnrollmentPage } from './reports/enrollment/scripts/observational-enrollment'; export { EnrollmentPage };
import { OptNowActivationPage } from './reports/activation/scripts/optnow-activation'; export { OptNowActivationPage };
import { CalculatorPage } from './studies/phase2/scripts/calculator.page'; export { CalculatorPage };
import { OptNowEnrollmentPage } from './reports/enrollment/scripts/optnow-enrollment'; export { OptNowEnrollmentPage };

// STYLES
import 'jstree/dist/themes/default/style.min.css';
import './home/home.scss';
import './resources/gallery.scss';
import './resources/consortium.scss';
import './announcements/announcements.scss';
import './reports/enrollment/observational.scss';
import './reports/activation/optnow.scss';
import 'tempusdominus-bootstrap-4/build/css/tempusdominus-bootstrap-4.min.css';